"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  INITIAL: 'INITIAL',
  MEETING: 'MEETING',
  CALL: 'CALL',
  CHAT: 'CHAT',
  EMAIL: 'EMAIL'
};
exports.default = _default;
module.exports = exports.default;